import React, { useState, useEffect } from "react";
import Sidebar from "../Component/Sidebar";
import AverageProgress from "../Component/AverageProgress";
import "../Assets/Css/Dashboard.css";
import BestPerformingSchoolList from "../Component/BestPerformingSchoolList";
import VideoWatchingProgress from "../Component/VideoWatchingProgress";
import Loader from "../Component/Loader";
import notificationBell from "../Assets/Images/Dashboard/notification_bell_icon.svg";
import { useNavigate } from "react-router-dom";

const Dashboard = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [userRole, setUserRole] = useState("");
  const [token, setToken] = useState("");
  const [notificationCount, setNotificationCount] = useState(1);
  const navigator = useNavigate();


  useEffect(() => {
    setUserRole(localStorage.getItem("user_role"));
    setToken(localStorage.getItem("authToken"));

    // Simulate real-time notifications
    // const notificationInterval = setInterval(() => {
    //   fetch("API_ENDPOINT_FOR_NOTIFICATION_COUNT", {
    //     method: "GET",
    //     headers: {
    //       Authorization: `Bearer ${token}`,
    //     },
    //   })
    //     .then((res) => res.json())
    //     .then((data) => setNotificationCount(data.count || 0))
    //     .catch((err) => console.error("Error fetching notifications", err));
    // }, 5000);
    // Poll every 5 seconds

    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 2000); // 1 minute in milliseconds

    return () => clearTimeout(timeout);
  }, []);

  const getTitle = () => {
    switch (userRole) {
      case "Principal":
        return "Principal Dashboard";
      case "Admin":
        return "Admin Dashboard";
      case "Diet":
        return "DIET Dashboard";
      default:
        return "Dashboard";
    }
  };

  const handleNotificationClick = () => {
    navigator("/notifications"); // Redirect to notification component
  };

  return (
    <>
      <Sidebar />
      {isLoading ? (
        <Loader />
      ) : (
        <div className="sidebody">
          <div className="container">
            {/* {userRole === "Principal" ? (
              <div className="row">
                <div className="col-11">
                  <p className="admin_title">{getTitle()}</p>
                </div>
                <div className="col-1 notification-bell-wrapper" onClick={handleNotificationClick}>
                  <img src={notificationBell} alt="notification-bell" width="34px"/>
                  {notificationCount > 0 && (
                    <span
                      className=" notification-count"
                      style={{ fontSize: "12px" }}  
                    >
                      {notificationCount}
                    </span>
                  )}
                </div>
              </div>
            ) : (
              <p className="admin_title">{getTitle()}</p>
            )} */}
            <p className="admin_title">{getTitle()}</p>
            <VideoWatchingProgress />
            <AverageProgress />
            {userRole === "Admin" && <BestPerformingSchoolList />}
          </div>
        </div>
      )}
    </>
  );
};

export default Dashboard;
